import { usePermissionContext } from '../contexts/PermissionContext';
import type { PermissionKey } from '../types/permissions';

export function usePermission(key: PermissionKey): { allowed: boolean; loading: boolean } {
  const { hasPermission, loading } = usePermissionContext();
  return { allowed: hasPermission(key), loading };
}

export function useAnyPermission(keys: PermissionKey[]): { allowed: boolean; loading: boolean } {
  const { hasAnyPermission, loading } = usePermissionContext();
  return { allowed: hasAnyPermission(keys), loading };
}
